
import { ControlFacet } from '../models/controls/ControlFacet';

/**
 * Control facet used to override what components within an ItemsScope treat as the 'current item set'.
 * This overrides the behavior of withCurrentItemSet so that downstream components will see an alternate
 * list of items.
 *
 * Use this control to sort, group, or filter items in an alternate way than the current navigation would
 * require, if appropriate.
 * For example, a specific layout may require grouping of the items, but the user did not explicitly choose it.
 * Or, when picking a file, this may be used to enforce filters beyond what the user could normally apply.
 *
 * In general, this control should be used sparingly! It can cause a lot of confusion to both developers and users
 * if employed without caution.
 */
export const currentItemSetControl: ControlFacet<{
  /**
   * The current items scope within which to evaliate the current item set.
   * Use this to use a completely different facet of the Items Scope to determine the current item.
   */
  itemsScopeItemKey?: string;
}, {
    /**
     * An override for what is to be seen as the current item set, if applicable.
     */
    itemKey: string;
  }> = new ControlFacet('currentItemSet');
